import type { ApiClient } from "../auth/apiClient";
import {
    EntityCandidatesResponseSchema,
    EntityResolveResponseSchema,
} from "./types";
import type { EntityCandidatesResponse, EntityResolveResponse } from "./types";

export async function searchEntityCandidates(
    client: ApiClient,
    type: string,
    query: string,
    top = 5,
): Promise<EntityCandidatesResponse> {
    const params = new URLSearchParams({ type, q: query, top: String(top) });
    const response = await client.fetch(`/entity-candidates?${params.toString()}`);

    if (!response.ok) {
        throw new Error(
            `Entity candidate search failed: ${String(response.status)} ${response.statusText}`,
        );
    }

    const json: unknown = await response.json();
    return EntityCandidatesResponseSchema.parse(json);
}

export async function resolveEntity(
    client: ApiClient,
    type: string,
    id: string,
): Promise<EntityResolveResponse> {
    const params = new URLSearchParams({ type, id });
    const response = await client.fetch(`/entity-resolve?${params.toString()}`);

    if (!response.ok) {
        throw new Error(
            `Entity resolve failed: ${String(response.status)} ${response.statusText}`,
        );
    }

    const json: unknown = await response.json();
    return EntityResolveResponseSchema.parse(json);
}
